/*

File handles all api calls for vendors

*/

import { server } from '../engine/server'
import { modal } from '../utilities/modal'

var Payables = Class.create({
  	initialize: function() {
  		this.server = server;
	},
	getVendors: function(filter, callback) {
		var url = "vendors";
		if (filter != null) {
			url = url + "?filter=" + filter;
		}
		var data = this.server.getData(url, null, true);
		data
		.done(function(response){
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
                modal.showInfo("Oops! " + response.data.error, "danger", "top", "center");
			} else {
                if (callback) {
                    callback(response);
                }
            }
		})
		.fail(function(e){
			console.log(e);
		});
	},
	sendAlerts: function(content, callback) {
		var self = this;
		var url = "vendors/alert/all";
		var params = content
		modal.showDangerModalWithOK("Are you sure?","You are about to send out a mass alert to all vendors.","Yes, Alert All");
		jQuery(".move-on").on('click',function() {
			var data = self.server.getData(url, params, false, 'PUT');
			data
			.done(function(response){
				modal.showInfo("All Vendors have been alerted!", "success", "top", "center");
				if(callback) {
					callback();
				}
			})
			.fail(function(e){
				console.log(e);
			});
		});
	},
	sendEmail: function(data, callback) {
		var self = this;
		var url = "vendors/email";
		var params = data;
		var data = this.server.getData(url,params,false, "POST");
		data
		.done(function(response){
			// #  Validate response
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
			} else {
				if(callback) {
					callback(response);
				}
			}
		})
		.fail(function(e){
			modal.showInfo("Oops! Looks like you are missing data.", "warning", "top", "center");
		});
	},
	getVendorBills: function(callback) {
		var url = "vendor/bills";
		var data = server.getData(url, null, true);
		data
		.done(function(response){
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
                modal.showInfo("Oops! " + response.data.error, "danger", "top", "center");
			} else {
                if (callback) {
                    callback(response);
                }
            }
		})
		.fail(function(e){
			modal.showInfo("Oops! " + e, "danger", "top", "center");
		});
	},
	getVendorBillsPending: function(callback) {
		var url = "vendor/bills/pending";
		var data = server.getData(url, null, true);
		data
		.done(function(response){
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
                modal.showInfo("Oops! " + response.data.error, "danger", "top", "center");
			} else {
                if (callback) {
                    callback(response);
                }
            }
		})
		.fail(function(e){
			modal.showInfo("Oops! " + e, "danger", "top", "center");
		});
	},
	getVendorBillsApproved: function(callback) {
		var url = "vendor/bills/approved";
		var data = server.getData(url, null, true);
		data
		.done(function(response){
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
                modal.showInfo("Oops! " + response.data.error, "danger", "top", "center");
			} else {
                if (callback) {
                    callback(response);
                }
            }
		})
		.fail(function(e){
			modal.showInfo("Oops! " + e, "danger", "top", "center");
		});
	},
	getVendorBillsDeclined: function(callback) {
		var url = "vendor/bills/declined";
		var data = server.getData(url, null, true);
		data
		.done(function(response){
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
                modal.showInfo("Oops! " + response.data.error, "danger", "top", "center");
			} else {
                if (callback) {
                    callback(response);
                }
            }
		})
		.fail(function(e){
			modal.showInfo("Oops! " + e, "danger", "top", "center");
		});
	},
});

export let payables = new Payables();



// WEBPACK FOOTER //
// app/core/controllers/Payables.js